import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { of, concat } from "rxjs";
import { concatMap, tap } from "rxjs/operators";

@Component({
  selector: "app-graphic-average-time-sst",
  templateUrl: "./graphic-average-time-sst.component.html",
  styleUrls: ["./graphic-average-time-sst.component.scss"],
})
export class GraphicAverageTimeSstComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input()
  mesesProgramadores = [];

  @Input()
  alerta: any = null;

  spinnerGraphicAverageTimeSst = true;

  chart1: any;
  xaxisChart1 = [];
  graphic1: any = null;
  dataChart1: any = [];
  maxYaxisChart1: any;
  labelChart1: any = [];
  enableSeriesIndex: any = [];

  constructor() {
    this.chart1 = {
      series: [],
      chart: {
        type: "line",
        height: 350,
        stacked: true,
        zoom: {
          enabled: true,
        },
        toolbar: {
          tools: {
            zoomin: true,
            zoomout: true,
            selection: true,
            pan: true,
            reset: true,
          },
        },
      },
      labels: [],
      stroke: {
        width: [0, 4],
        colors: ["#fff"],
      },
      dataLabels: {
        enabled: true,
        // enabledOnSeries : [4,5,6],
        enabledOnSeries: null,
        offsetY: 0,
        // textAnchor: "end",
        formatter: function (val, opts) {
          return val || "";
        },
        // offsetY: ,
        // distributed: true,
        style: {
          fontSize: "1em",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: "bold",
          colors: undefined,
        },
        background: {
          enabled: true,
          foreColor: '#fff',
          padding: 0,
          borderRadius: 1,
          borderWidth: 1,
          borderColor: '#fff',
          opacity: 0.9,
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.45
          }
        },
        dropShadow: {
          enabled: true,
          left: 2,
          top: 2,
          opacity: 0.5,
        },
      },
      plotOptions: {
        bar: {
          // columnWidth: '55%',
          horizontal: false,
          dataLabels: {
            // position: 'center'
          }
        },
      },
      fill: {
        opacity: 1,
      },
      xaxis: {
        categories: this.xaxisChart1,
        labels: {
          // rotateAlways: true,
          // rotate: -45,
          formatter: function (value) {
            return value;
          },
          // tickPlacement: 'on'
        },
      },
      yaxis: [],
      tooltip: {
        enabled: true,
        shared: true,
        x: {
          show: true,
          format: "dd MMM",
          formatter: "n",
        },
        y: {
          formatter: function (val, opts) {
            return val ? val : val;
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        z: {
          formatter: "c",
          title: "Size: ",
        },
      },
      legend: {
        show: false,
        position: "top",
        horizontalAlign: "left",
      },
    };
  }
  ngOnChanges(changes: SimpleChanges): void {

    // this.ngOnInit()
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    of({})
      .pipe(
        tap({
          next: (data) => {
            this.graphicInsert();
          },
          error: (error) => { },
          complete: () => {
            this.spinnerGraphicAverageTimeSst = false;
          },
        })
      )
      .subscribe();
  }

  graphicInsert() {
    const chartElement = document.querySelector("#chart1");

    if (this.graphic1) {
      this.graphic1.destroy();
      this.xaxisChart1 = [];
      this.dataChart1 = [];
      this.chart1.dataLabels.enabledOnSeries = null;
    }

    this.mesesProgramadores.forEach((mes, index) => {
      const split = mes.mes.split(" ");
      this.xaxisChart1.push(
        split[0].substring(0, 3).toUpperCase() + " " + split[1]
      );
    });

    if (chartElement) {
      const sstsData = {
        name: "SSTs",
        group: "meses",
        type: "column",
        data: [],
        color: this.getRandomColor(),
      };

      const alertas = {
        name: "Alertas",
        type: "column",
        group: "meses",
        data: [],
        color: this.getRandomColor(),
      };

      const tiempoPromedio = {
        name: "Tiempo promedio",
        type: "line",
        group: "meses",
        data: [],
        color: this.getRandomColor(),
      };

      const programadores = [];
      const alertasProgramadores = [];
      const tiempoProgramadores = [];

      this.mesesProgramadores.forEach((mes, index) => {
        if (mes.programadores.length <= 0) {
          alertas.data.push(
            mes.alerta > 0 &&
              parseFloat(mes.sstsCantidad) > parseFloat(this.alerta)
              ? parseFloat(mes.sstsCantidad) - parseFloat(this.alerta)
              : 0
          );
          sstsData.data.push(mes.sstsCantidad);
          tiempoPromedio.data.push(mes.tiempoPromedio);
        } else {
          mes.programadores.forEach((programador, index) => {
            let find = programadores.find((element) => {
              return element.group == programador.username;
            });
            if (!find) {
              let color = this.getRandomColor();
              programadores.push({
                name: "SSTs " + programador.username,
                group: programador.username,
                type: "column",
                data: [],
                color: color,
              });
              alertasProgramadores.push({
                name: "Alerta " + programador.username,
                group: programador.username,
                type: "column",
                data: [],
                color: this.getRandomColor(),
              });
              tiempoProgramadores.push({
                name: "Tiempo promedio " + programador.username,
                group: programador.username,
                type: "line",
                data: [],
                color: color,
              });
            }
          });
        }
      });

      this.mesesProgramadores.forEach((mes, index) => {
        const mesFind = this.mesesProgramadores.find((mesSearch) => { return mesSearch.mes.includes(mes.mes) });
        const indexMes = this.mesesProgramadores.indexOf(mesFind);
        mes.programadores.forEach((programador, index) => {
          let findGroupSsta = programadores.find((element) => { return element.group.includes(programador.username) });
          let findGroupTiempo = tiempoProgramadores.find((element) => { return element.group.includes(programador.username)})
          let findGroupAlertas = alertasProgramadores.find((element) => { return element.group.includes(programador.username)});

          findGroupSsta.data[indexMes] = programador.sstsCantidad;
          findGroupTiempo.data[indexMes] = programador.tiempoPromedio;
          findGroupAlertas.data[indexMes] =
            programador.alerta > 0 &&
              parseFloat(programador.sstsCantidad) > parseFloat(this.alerta)
              ? parseFloat(programador.sstsCantidad) - parseFloat(this.alerta)
              : 0;
        });
      });

      if (programadores.length > 0) {
        let maxDataSst = 0;
        let maxTiempo = 0;
        let maxAlertas = 0;

        const allDataProgramadores = programadores
          .map((t) => t.data) // Obtiene todos los arrays data
          .reduce((acc, val) => acc.concat(val), []) // Aplana el array
          .filter(Number.isFinite);
        const allDataTiempo = tiempoProgramadores
          .map((t) => t.data) // Obtiene todos los arrays data
          .reduce((acc, val) => acc.concat(val), []) // Aplana el array
          .filter(Number.isFinite);
        const allDataAlerta = alertasProgramadores
          .map((t) => t.data) // Obtiene todos los arrays data
          .reduce((acc, val) => acc.concat(val), []) // Aplana el array
          .filter(Number.isFinite);

        of({})
          .pipe(
            tap({
              next: (data) => {
                maxDataSst =
                  allDataProgramadores.length > 0
                    ? Math.max(...allDataProgramadores)
                    : 0;
                maxTiempo =
                  allDataTiempo.length > 0 ? Math.max(...allDataTiempo) : 0;
                maxAlertas =
                  allDataAlerta.length > 0 ? Math.max(...allDataAlerta) : 0;

                this.maxYaxisChart1 =
                  Math.max(maxDataSst, maxTiempo, maxAlertas) + 50;
              },
              error: (error) => { },
            }),
            concatMap(() =>
              concat(
                of(
                  this.dataChart1.push(...programadores),
                  this.dataChart1.push(...alertasProgramadores),
                  this.dataChart1.push(...tiempoProgramadores)
                )
              )
            ),
            concatMap(() =>
              concat(
                of(
                  (this.chart1.yaxis = [
                    {
                      seriesName: [...this.getSeriesName(tiempoProgramadores)],
                      opposite: true,
                      min: 0,
                      max: maxTiempo + 5,
                      title: {
                        text: "Tiempo",
                      },
                      labels: {
                        formatter: function (value) {
                          return parseInt(value);
                        },
                        colors: "#CCCCCC",
                      },
                    },
                    {
                      seriesName: [
                        ...this.getSeriesName(programadores),
                        ...this.getSeriesName(alertasProgramadores),
                      ],
                      min: 0,
                      max: maxDataSst + (maxAlertas || 0) + 100,
                      title: {
                        text: "SSTs",
                      },
                      labels: {
                        formatter: function (value) {
                          return parseInt(value);
                        },
                      },
                    },
                  ])
                )
              )
            )
          )
          .subscribe();

        if (this.dataChart1.length > 3) {
          this.chart1.dataLabels.enabledOnSeries = this.getIndexTimeGraphic();
        }
      } else {
        const allDataSst = sstsData.data.length > 0 ? Math.max(...sstsData.data) : 0;
        const allDataTiempo = tiempoPromedio.data.length ? Math.max(...tiempoPromedio.data) : 0;
        const allDataAlertas = alertas.data ? Math.max(...alertas.data) : 0;

        this.maxYaxisChart1 = Math.max(allDataSst, allDataTiempo, allDataAlertas) + 50;

        this.dataChart1.push(sstsData);
        this.dataChart1.push(alertas);
        this.dataChart1.push(tiempoPromedio);

        this.chart1.yaxis = [
          {
            seriesName: [...this.getSeriesName([tiempoPromedio])],
            opposite: true,
            min: 0,
            max: allDataTiempo + 5,
            title: {
              text: "Tiempo",
            },
            labels: {
              formatter: function (value) {
                return parseInt(value);
              },
              colors: "#CCCCCC",
            },
            tooltip: {
              enabled: false,
              offsetX: 0,
          },
          },
          {
            seriesName: [...this.getSeriesName([sstsData]), ...this.getSeriesName([alertas])],
            min: 0,
            max: allDataSst + allDataAlertas + 10,
            title: {
              text: "SSTs",
            },
            labels: {
              formatter: function (value) {
                return parseInt(value);
              },
              colors: "#CCCCCC",
            },
          },

        ];
      }
      this.chart1.labels = this.xaxisChart1;
      this.chart1.series = this.dataChart1;

      this.graphic1 = new ApexCharts(chartElement, this.chart1);

      this.graphic1.render();
    }
  }

  getSeriesName(serie: any[]) {
    const seriesName = [];

    serie.forEach((element) => {
      seriesName.push(element.name);
    });

    return seriesName;
  }

  getIndexTimeGraphic() {
    const indices = this.dataChart1
      .map((item, index) => item.name.includes('Tiempo') ? index : -1)
      .filter(index => index !== -1);
    return indices
  }

  getRandomColor(): string {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 3; i++) {
      // Limita los valores de los colores a una gama oscura (0-7)
      const randomValue = Math.floor(Math.random() * 8);
      color += letters[randomValue] + letters[randomValue]; // Duplícalo para asegurar que sea un color medio a oscuro
    }
    return color;
  }
}
